// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-kpi-image {
  width: 54px;
  height: 50px;
  margin-right: 8px;
  object-fit: contain;
  vertical-align: middle;
  display: inline-block;
}

.production-dashboard-section {
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.production-dashboard-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-radius: 24px;
  background: radial-gradient(circle at top left, rgba(37, 99, 235, 0.18), transparent 34%), linear-gradient(135deg, #ffffff 0%, #f8fbff 52%, #eef6ff 100%);
  border: 1px solid #e5edf8;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.07);
}
.production-dashboard-header h2 {
  margin: 6px 0 8px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.04em;
}
.production-dashboard-header p {
  margin: 0;
  max-width: 760px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

.section-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.production-actions {
  display: inline-flex;
  padding: 5px;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #dbe3f3;
}
.production-actions button {
  border: 0;
  background: transparent;
  color: #475569;
  padding: 9px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.2s ease;
}
.production-actions button.active {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.25);
}

.production-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
}

.production-kpi-card {
  position: relative;
  overflow: hidden;
  padding: 8px 20px;
  border-radius: 22px;
  background: #ffffff;
  border: 1px solid #e8edf7;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.06);
}
.production-kpi-card::after {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  right: -48px;
  top: -48px;
  border-radius: 50%;
  opacity: 0.16;
}
.production-kpi-card span {
  display: block;
  color: #64748b;
  font-size: 13px;
  font-weight: 680;
}
.production-kpi-card strong {
  display: block;
  color: #0f172a;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.6px;
}
.production-kpi-card small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}
.production-kpi-card.primary::after {
  background: #2563eb;
}
.production-kpi-card.success::after {
  background: #16a34a;
}
.production-kpi-card.danger::after {
  background: #ef4444;
}
.production-kpi-card.warning::after {
  background: #f59e0b;
}
.production-kpi-card.purple::after {
  background: #7c3aed;
}

.production-chart-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(320px, 0.8fr);
  gap: 18px;
}
.production-chart-grid > :only-child {
  grid-column: 1/-1;
}

.production-dashboard-card {
  background: #ffffff;
  border: 1px solid #e8edf7;
  border-radius: 24px;
  padding: 22px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);
}
.production-dashboard-card.large {
  min-width: 0;
}

.card-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 16px;
}
.card-title-row h3 {
  margin: 0;
  color: #0f172a;
  font-size: 20px;
  font-weight: 640;
  letter-spacing: -0.03em;
}
.card-title-row p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}

.reject-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reject-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}
.reject-row strong {
  display: block;
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
}
.reject-row span {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}

.reject-percent {
  min-width: 58px;
  text-align: center;
  padding: 7px 10px;
  border-radius: 999px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 900;
}

.table-card {
  padding-bottom: 16px;
}

.production-summary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 9px 14px;
  border: 1px solid #b7ddc5;
  border-radius: 10px;
  background: #ecfdf3;
  color: #087443;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  transition: 160ms ease;
}
.production-summary-download:hover:not(:disabled) {
  border-color: #75c493;
  background: #dcfce7;
  transform: translateY(-1px);
}
.production-summary-download:focus-visible {
  outline: 3px solid rgba(34, 197, 94, 0.2);
  outline-offset: 2px;
}
.production-summary-download:disabled {
  cursor: wait;
  opacity: 0.65;
}

.production-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.production-table {
  width: 100%;
  min-width: 960px;
  border-collapse: collapse;
}
.production-table th {
  text-align: left;
  padding: 13px 14px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e8edf7;
}
.production-table th:first-child {
  border-radius: 14px 0 0 14px;
}
.production-table th:last-child {
  border-radius: 0 14px 14px 0;
}
.production-table td {
  padding: 14px;
  color: #334155;
  font-size: 14px;
  border-bottom: 1px solid #eef2f7;
  white-space: nowrap;
  letter-spacing: 0.8px;
}
.production-table td strong {
  color: #0f172a;
  font-weight: 780;
}
.production-table tr:hover td {
  background: #f8fbff;
}

.production-table__detail-link {
  display: inline-flex;
  min-width: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 8px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: #25415f;
  font: inherit;
  font-weight: 800;
  cursor: pointer;
  transition: 160ms ease;
}
.production-table__detail-link i {
  color: #8aa0b8;
  font-size: 10px;
  opacity: 0;
  transform: translate(-2px, 2px);
  transition: 160ms ease;
}
.production-table__detail-link:hover, .production-table__detail-link:focus-visible {
  border-color: #c8d9ed;
  background: #edf5ff;
  color: #075bbd;
  outline: none;
}
.production-table__detail-link:hover i, .production-table__detail-link:focus-visible i {
  opacity: 1;
  transform: translate(0, 0);
}
.production-table__detail-link.is-reject {
  color: #d92d20;
}
.production-table__detail-link.is-reject:hover, .production-table__detail-link.is-reject:focus-visible {
  border-color: #fecaca;
  background: #fff1f0;
  color: #b42318;
}
.production-table__detail-link.is-rework {
  color: #c56a00;
}
.production-table__detail-link.is-rework:hover, .production-table__detail-link.is-rework:focus-visible {
  border-color: #fed7aa;
  background: #fff7e8;
  color: #9a4d00;
}

.department-detail-modal {
  position: fixed;
  z-index: 2200;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  background: rgba(8, 24, 43, 0.56);
  backdrop-filter: blur(3px);
}

.department-detail-modal__dialog {
  display: flex;
  width: min(1440px, 96vw);
  max-height: 90vh;
  overflow: hidden;
  flex-direction: column;
  border: 1px solid #d8e3f0;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(15, 36, 61, 0.3);
}

.department-detail-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px 19px;
  border-bottom: 1px solid #e3eaf2;
  background: linear-gradient(135deg, #f7fbff 0%, #ffffff 65%);
}

.department-detail-modal__heading {
  display: flex;
  align-items: center;
  gap: 14px;
}
.department-detail-modal__heading h2 {
  margin: 3px 0 0;
  color: #102a45;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.department-detail-modal__heading p {
  margin: 4px 0 0;
  color: #667b93;
  font-size: 12px;
}

.department-detail-modal__eyebrow {
  color: #0872ce;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.department-detail-modal__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(145deg, #087de0, #0757b4);
  color: #ffffff;
  box-shadow: 0 7px 17px rgba(7, 91, 189, 0.25);
  font-size: 18px;
}

.department-detail-modal__close {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9e3ee;
  border-radius: 10px;
  background: #ffffff;
  color: #4b6179;
  cursor: pointer;
  transition: 150ms ease;
}
.department-detail-modal__close:hover, .department-detail-modal__close:focus-visible {
  border-color: #b9cbe0;
  background: #f2f7fc;
  color: #102a45;
  outline: none;
}

.department-detail-modal__toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 24px;
  border-bottom: 1px solid #e7edf4;
  background: #fbfdff;
}

.department-detail-modal__stats {
  display: flex;
  align-items: stretch;
  gap: 10px;
}
.department-detail-modal__stats > div {
  min-width: 145px;
  padding: 9px 12px;
  border: 1px solid #dce6f0;
  border-radius: 10px;
  background: #ffffff;
}
.department-detail-modal__stats span,
.department-detail-modal__stats strong {
  display: block;
}
.department-detail-modal__stats span {
  color: #73869c;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.department-detail-modal__stats strong {
  margin-top: 4px;
  color: #15395f;
  font-size: 14px;
  font-weight: 850;
}

.department-detail-modal__search {
  display: flex;
  width: min(430px, 100%);
  height: 40px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #cdd9e7;
  border-radius: 9px;
  background: #ffffff;
  transition: 150ms ease;
}
.department-detail-modal__search:focus-within {
  border-color: #2483d5;
  box-shadow: 0 0 0 3px rgba(36, 131, 213, 0.11);
}
.department-detail-modal__search > i {
  margin-left: 12px;
  color: #7890a8;
}
.department-detail-modal__search input {
  min-width: 0;
  height: 100%;
  flex: 1 1;
  padding: 0 10px;
  border: 0;
  outline: 0;
  color: #203b58;
  font-size: 12px;
}

.department-detail-modal__clear {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #7a8fa5;
  cursor: pointer;
}

.department-detail-modal__search-button {
  align-self: stretch;
  padding: 0 16px;
  border: 0;
  background: #0875cf;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.department-detail-modal__body {
  min-height: 260px;
  overflow: auto;
  flex: 1 1;
}

.department-detail-modal__table-wrapper {
  min-width: 980px;
}

.department-detail-modal__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.department-detail-modal__table th {
  position: sticky;
  z-index: 2;
  top: 0;
  padding: 12px 14px;
  border-bottom: 1px solid #cfdce9;
  background: #eaf2fa;
  color: #244361;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.035em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}
.department-detail-modal__table td {
  padding: 11px 14px;
  border-bottom: 1px solid #e8eef5;
  background: #ffffff;
  color: #35516e;
  font-size: 12px;
  vertical-align: middle;
  white-space: nowrap;
}
.department-detail-modal__table tbody tr:nth-child(even) td {
  background: #fbfdff;
}
.department-detail-modal__table tbody tr:hover td {
  background: #f2f7fd;
}

.department-detail-modal__identity {
  min-width: 140px;
}
.department-detail-modal__identity strong,
.department-detail-modal__identity span {
  display: block;
}
.department-detail-modal__identity strong {
  overflow: hidden;
  max-width: 260px;
  color: #173651;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
}
.department-detail-modal__identity span {
  margin-top: 3px;
  color: #7a8da2;
  font-size: 10px;
  font-weight: 650;
}

.department-detail-modal__quantity {
  display: inline-flex;
  min-width: 62px;
  justify-content: center;
  padding: 5px 8px;
  border-radius: 7px;
  background: #e9f1fb;
  color: #1c4f80;
  font-weight: 800;
}
.department-detail-modal__quantity.is-ok {
  background: #e2f5e8;
  color: #167441;
}
.department-detail-modal__quantity.is-reject {
  background: #ffebe9;
  color: #b42318;
}
.department-detail-modal__quantity.is-rework {
  background: #fff2d8;
  color: #9a5c00;
}

.department-detail-modal__count {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.department-detail-modal__count strong {
  color: #193c5f;
  font-size: 13px;
}
.department-detail-modal__count span {
  color: #8293a6;
  font-size: 10px;
}

.department-detail-modal__jobcard {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 999px;
  background: #e3ecf9;
  color: #174a82;
  font-weight: 800;
}

.department-detail-modal__state {
  display: flex;
  min-height: 270px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 9px;
  color: #657a90;
}
.department-detail-modal__state > i {
  color: #8ca2b9;
  font-size: 28px;
}
.department-detail-modal__state strong {
  color: #294866;
}
.department-detail-modal__state span {
  font-size: 12px;
}
.department-detail-modal__state.is-error, .department-detail-modal__state.is-error i, .department-detail-modal__state.is-error strong {
  color: #b42318;
}

.department-detail-modal__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #dce8f3;
  border-top-color: #0875cf;
  border-radius: 50%;
  animation: departmentDetailSpin 0.75s linear infinite;
}

@keyframes departmentDetailSpin {
  to {
    transform: rotate(360deg);
  }
}
.department-detail-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 24px;
  border-top: 1px solid #dfe8f1;
  background: #f8fbfe;
  color: #647b92;
  font-size: 11px;
}
.department-detail-modal__footer > div {
  display: flex;
  align-items: center;
  gap: 10px;
}
.department-detail-modal__footer button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid #cfdae6;
  border-radius: 7px;
  background: #ffffff;
  color: #315371;
  font-size: 11px;
  font-weight: 750;
  cursor: pointer;
}
.department-detail-modal__footer button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.department-detail-modal__footer strong {
  color: #2b4965;
  font-size: 11px;
}

.success-text {
  color: #15803d !important;
  font-weight: 800;
}

.danger-text {
  color: #dc2626 !important;
  font-weight: 800;
}

.warning-text {
  color: #d97706 !important;
  font-weight: 800;
}

.loading-card,
.empty-card {
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.loading-card h3,
.empty-card h3 {
  margin: 0 0 8px;
  color: #0f172a;
}
.loading-card p,
.empty-card p {
  margin: 0;
  color: #64748b;
}

@media (max-width: 1200px) {
  .production-kpi-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .production-chart-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .production-dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
  .production-dashboard-header h2 {
    font-size: 21px;
  }
  .production-kpi-grid {
    grid-template-columns: 1fr;
  }
  .production-dashboard-card {
    padding: 18px;
    border-radius: 20px;
  }
  .department-detail-modal {
    align-items: flex-end;
    padding: 0;
  }
  .department-detail-modal__dialog {
    width: 100%;
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
  .department-detail-modal__header,
  .department-detail-modal__toolbar,
  .department-detail-modal__footer {
    padding-right: 16px;
    padding-left: 16px;
  }
  .department-detail-modal__toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .department-detail-modal__stats {
    overflow-x: auto;
  }
  .department-detail-modal__stats > div {
    min-width: 135px;
  }
  .department-detail-modal__search {
    width: 100%;
  }
  .department-detail-modal__footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .department-detail-modal__footer > div {
    width: 100%;
    justify-content: space-between;
  }
}
.animated-kpi-grid {
  perspective: 1000px;
}

.animated-kpi-card {
  position: relative;
  overflow: hidden;
  opacity: 0;
  /* Slower card entry */
  animation: kpiCardEntry 1.25s ease forwards;
  animation-delay: var(--delay);
  transition: transform 0.6s ease, box-shadow 0.6s ease, filter 0.6s ease;
}

.animated-kpi-card:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  filter: brightness(1.04);
}

.animated-kpi-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 55%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.35), transparent);
  transform: skewX(-20deg);
  /* Slower shine effect */
  transition: left 1.3s ease;
  pointer-events: none;
}

.animated-kpi-card:hover::before {
  left: 130%;
}

.animated-kpi-card span {
  display: inline-block;
  /* Slower text animation */
  animation: kpiTextSlide 1s ease forwards;
  animation-delay: calc(var(--delay) + 250ms);
}

.animated-kpi-card strong {
  display: flex;
  align-items: center;
  gap: 8px;
  /* Slower value pop */
  animation: kpiValuePop 1.15s ease forwards;
  animation-delay: calc(var(--delay) + 350ms);
}

.animated-kpi-card small {
  display: inline-block;
  /* Slower bottom text fade */
  animation: kpiSmallFade 1.1s ease forwards;
  animation-delay: calc(var(--delay) + 450ms);
}

.animated-kpi-card .dashboard-kpi-image {
  /* Slower image bounce */
  animation: kpiImageBounce 1.45s ease forwards;
  animation-delay: calc(var(--delay) + 300ms);
  transition: transform 0.6s ease;
}

.animated-kpi-card:hover .dashboard-kpi-image {
  transform: rotate(-6deg) scale(1.15);
}

@keyframes kpiCardEntry {
  0% {
    opacity: 0;
    transform: translateY(28px) scale(0.94) rotateX(8deg);
  }
  60% {
    opacity: 1;
    transform: translateY(-3px) scale(1.015) rotateX(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1) rotateX(0);
  }
}
@keyframes kpiTextSlide {
  0% {
    opacity: 0;
    transform: translateX(-14px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes kpiValuePop {
  0% {
    opacity: 0;
    transform: scale(0.86);
  }
  65% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes kpiSmallFade {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes kpiImageBounce {
  0% {
    opacity: 0;
    transform: scale(0.55) rotate(-12deg);
  }
  55% {
    opacity: 1;
    transform: scale(1.16) rotate(5deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}
.card-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.card-title-row > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.card-title-row h3 {
  margin: 0 0 5px;
}
.card-title-row p {
  margin: 0;
}

.chart-view-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), inset 0 1px 2px rgba(15, 23, 42, 0.02);
}
.chart-view-switch button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 32px;
  padding: 6px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}
.chart-view-switch button:hover:not(.active) {
  color: #053c83;
  background: rgba(5, 60, 131, 0.06);
}
.chart-view-switch button:active {
  transform: scale(0.97);
}
.chart-view-switch button.active {
  color: #ffffff;
  background: linear-gradient(135deg, #053c83 0%, #2f539d 100%);
  box-shadow: 0 4px 10px rgba(5, 60, 131, 0.2), 0 1px 2px rgba(5, 60, 131, 0.15);
}
.chart-view-switch button.active span {
  color: #ffffff;
}
.chart-view-switch button.active .chart-switch-icon {
  color: #ffffff;
}

.chart-switch-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
}
.chart-switch-icon svg {
  width: 16px;
  height: 16px;
  display: block;
}

.column-icon {
  align-items: flex-end;
  gap: 2px;
}
.column-icon i {
  display: block;
  width: 3px;
  border-radius: 2px 2px 1px 1px;
  background: currentColor;
}
.column-icon i:nth-child(1) {
  height: 7px;
}
.column-icon i:nth-child(2) {
  height: 13px;
}
.column-icon i:nth-child(3) {
  height: 10px;
}

.production-trend-chart-wrapper,
.department-quality-chart-wrapper {
  width: 100%;
  min-height: 390px;
}
.production-trend-chart-wrapper .apexcharts-canvas,
.department-quality-chart-wrapper .apexcharts-canvas {
  margin: 0 auto;
}

.chart-empty-state {
  min-height: 390px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.6), rgba(255, 255, 255, 0));
  border-radius: 12px;
}

@media (max-width: 768px) {
  .card-title-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .chart-view-switch {
    align-self: flex-start;
  }
}
@media (max-width: 480px) {
  .chart-view-switch {
    width: 100%;
  }
  .chart-view-switch button {
    flex: 1 1;
  }
}
.production-mix-focus {
  width: 100%;
  animation: productionMixFocusReveal 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.production-mix-selector {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.production-mix-selector-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  padding: 11px 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: linear-gradient(145deg, #ffffff, #f8fafc);
  cursor: pointer;
  opacity: 0;
  transform: translateY(10px);
  animation: productionMixSelectorReveal 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: var(--delay);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.production-mix-selector-item::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  content: "";
  background: var(--metric-color);
  opacity: 0.45;
  transition: height 0.2s ease, opacity 0.2s ease;
}
.production-mix-selector-item:hover {
  transform: translateY(-2px);
  border-color: color-mix(in srgb, var(--metric-color) 35%, #e2e8f0);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}
.production-mix-selector-item.active {
  border-color: var(--metric-color);
  background: linear-gradient(145deg, color-mix(in srgb, var(--metric-color) 7%, #ffffff), #ffffff);
  box-shadow: 0 7px 20px color-mix(in srgb, var(--metric-color) 14%, transparent);
}
.production-mix-selector-item.active::before {
  height: 4px;
  opacity: 1;
}
.production-mix-selector-item.active .production-mix-selector-dot {
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--metric-color) 15%, transparent);
}
.production-mix-selector-item > strong {
  display: block;
  max-width: 100%;
  margin-top: 8px;
  overflow: hidden;
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.production-mix-selector-item > small {
  display: inline-flex;
  margin-top: 5px;
  padding: 3px 7px;
  border-radius: 999px;
  color: var(--metric-color);
  background: color-mix(in srgb, var(--metric-color) 9%, transparent);
  font-size: 10px;
  font-weight: 800;
}

.production-mix-selector-top {
  display: flex;
  align-items: center;
  gap: 7px;
}

.production-mix-selector-dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--metric-color);
  transition: box-shadow 0.2s ease;
}

.production-mix-selector-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.production-focus-content {
  display: grid;
  grid-template-columns: minmax(240px, 1.2fr) minmax(150px, 0.8fr);
  align-items: center;
  gap: 5px;
  min-height: 330px;
}

.production-focus-chart {
  min-width: 0;
}
.production-focus-chart .apexcharts-canvas {
  margin: 0 auto;
}

.production-focus-details {
  position: relative;
  padding: 18px 16px;
  border: 1px solid #e8edf5;
  border-radius: 15px;
  background: linear-gradient(145deg, color-mix(in srgb, var(--metric-color) 5%, #ffffff), #ffffff);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
  animation: productionFocusDetailsReveal 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.production-focus-details h4 {
  margin: 14px 0 4px;
  color: #64748b;
  font-size: 15px;
  font-weight: 660;
}

.production-focus-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 999px;
  color: var(--metric-color);
  background: color-mix(in srgb, var(--metric-color) 10%, transparent);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.production-focus-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--metric-color);
  animation: productionFocusDotPulse 1.8s ease-in-out infinite;
}

.production-focus-main-value {
  display: block;
  overflow: hidden;
  color: #0f172a;
  font-size: 25px;
  font-weight: 900;
  line-height: 1.15;
  letter-spacing: -0.035em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.production-focus-percentage-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 9px;
}
.production-focus-percentage-row > span {
  color: var(--metric-color);
  font-size: 17px;
  font-weight: 900;
}
.production-focus-percentage-row > small {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 600;
}

.production-focus-total {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #dbe3ec;
}
.production-focus-total > span {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 600;
}
.production-focus-total > strong {
  color: #334155;
  font-size: 14px;
  font-weight: 800;
}

.production-focus-tooltip {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 160px;
  padding: 11px 13px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.14);
}
.production-focus-tooltip strong {
  color: #0f172a;
  font-size: 17px;
  font-weight: 800;
}
.production-focus-tooltip small {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
}

.production-focus-tooltip-title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.production-focus-tooltip-dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
}

@keyframes productionMixFocusReveal {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes productionMixSelectorReveal {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes productionFocusDetailsReveal {
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes productionFocusDotPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.35);
    opacity: 0.65;
  }
}
@media (max-width: 900px) {
  .production-focus-content {
    grid-template-columns: 1fr;
  }
  .production-focus-details {
    margin-top: -20px;
  }
}
@media (max-width: 600px) {
  .production-mix-selector {
    grid-template-columns: 1fr;
  }
  .production-focus-content {
    min-height: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .production-mix-focus,
  .production-mix-selector-item,
  .production-focus-details,
  .production-focus-badge-dot {
    animation: none;
  }
}
.top-rejection-card {
  position: relative;
  overflow: hidden;
  animation: rejectionCardReveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.top-rejection-card::before {
  position: absolute;
  top: -80px;
  right: -80px;
  width: 180px;
  height: 180px;
  content: "";
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.03) 45%, transparent 72%);
  pointer-events: none;
  animation: rejectionCardGlow 4s ease-in-out infinite;
}

.rejection-alert-indicator {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 9px;
  border: 1px solid rgba(239, 68, 68, 0.15);
  border-radius: 999px;
  color: #dc2626;
  background: rgba(239, 68, 68, 0.06);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.rejection-alert-dot {
  position: relative;
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #ef4444;
  animation: rejectionAlertPulse 1.8s ease-in-out infinite;
}
.rejection-alert-dot::after {
  position: absolute;
  inset: -4px;
  content: "";
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 50%;
  animation: rejectionAlertRing 1.8s ease-out infinite;
}

.reject-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.reject-row {
  position: relative;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  min-width: 0;
  padding: 0px 13px 5px;
  overflow: hidden;
  border: 1px solid #e8edf5;
  border-radius: 13px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.035);
  opacity: 0;
  transform: translateY(16px) scale(0.985);
  animation: rejectionRowReveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: var(--reject-delay);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}
.reject-row::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  content: "";
  background: linear-gradient(180deg, #ef4444, #f97316);
  opacity: 0.6;
  transition: width 0.25s ease, opacity 0.25s ease;
}
.reject-row:hover {
  transform: translateY(-3px) scale(1.008);
  border-color: rgba(239, 68, 68, 0.2);
  background: linear-gradient(145deg, #ffffff 0%, rgba(254, 242, 242, 0.55) 100%);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08), 0 4px 10px rgba(239, 68, 68, 0.05);
}
.reject-row:hover::after {
  width: 5px;
  opacity: 1;
}
.reject-row:hover .reject-rank {
  transform: scale(1.08) rotate(-3deg);
}
.reject-row:hover .reject-percent {
  transform: scale(1.06);
}
.reject-row.highest-rejection {
  border-color: rgba(239, 68, 68, 0.24);
  background: linear-gradient(145deg, rgba(254, 242, 242, 0.95), #ffffff);
  box-shadow: 0 8px 22px rgba(239, 68, 68, 0.08);
}
.reject-row.highest-rejection::before {
  position: absolute;
  top: -60px;
  right: -50px;
  width: 130px;
  height: 130px;
  content: "";
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 68, 68, 0.12), transparent 68%);
  animation: highestRejectGlow 3s ease-in-out infinite;
}

.reject-rank {
  position: relative;
  z-index: 1;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(239, 68, 68, 0.14);
  border-radius: 10px;
  color: #dc2626;
  background: linear-gradient(145deg, rgba(254, 242, 242, 0.95), rgb(255, 255, 255));
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.07);
  font-size: 11px;
  font-weight: 900;
  transition: transform 0.25s ease;
}

.reject-info {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.reject-department-name-row {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}
.reject-department-name-row > strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 760;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  margin-top: 6px;
}

.highest-rejection-badge {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 3px 6px;
  border-radius: 999px;
  color: #dc2626;
  background: rgba(239, 68, 68, 0.09);
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  animation: highestBadgePulse 2s ease-in-out infinite;
}

.reject-quantity-text {
  display: block;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 600;
}
.reject-quantity-text strong {
  color: #ef4444;
  font-weight: 800;
}

.reject-progress-track {
  position: relative;
  width: 100%;
  height: 5px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf2f7;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.05);
}

.reject-progress-value {
  position: relative;
  width: var(--reject-progress);
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
  background: linear-gradient(90deg, #ef4444 0%, #f97316 100%);
  transform-origin: left center;
  animation: rejectionProgressGrow 1.2s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--reject-delay) + 250ms);
}
.reject-progress-value::after {
  position: absolute;
  top: 0;
  left: -50%;
  width: 40%;
  height: 100%;
  content: "";
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.75), transparent);
  transform: skewX(-20deg);
  animation: rejectionProgressShimmer 2.4s ease-in-out infinite;
  animation-delay: calc(var(--reject-delay) + 1.2s);
}

.reject-progress-glow {
  position: absolute;
  top: 50%;
  right: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.85), 0 0 14px rgba(249, 115, 22, 0.55);
  opacity: 0.9;
  transform: translate(40%, -50%);
  animation: rejectionProgressDotPulse 1.8s ease-in-out infinite;
}

.reject-percent-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  min-width: 70px;
}
.reject-percent-wrapper > small {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 640;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.reject-percent {
  display: inline-flex;
  align-items: baseline;
  padding: 7px 9px;
  border: 1px solid rgba(239, 68, 68, 0.12);
  border-radius: 9px;
  color: #dc2626;
  background: linear-gradient(145deg, rgb(254, 242, 242), rgb(255, 255, 255));
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.06);
  font-size: 14px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.025em;
  transition: transform 0.25s ease;
}
.reject-percent span {
  margin-left: 1px;
  font-size: 9px;
  font-weight: 800;
}

@keyframes rejectionCardReveal {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes rejectionRowReveal {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes rejectionProgressGrow {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes rejectionProgressShimmer {
  0% {
    left: -50%;
  }
  55%, 100% {
    left: 130%;
  }
}
@keyframes rejectionProgressDotPulse {
  0%, 100% {
    transform: translate(40%, -50%) scale(1);
    opacity: 0.85;
  }
  50% {
    transform: translate(40%, -50%) scale(1.35);
    opacity: 1;
  }
}
@keyframes rejectionAlertPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.35);
    opacity: 0.7;
  }
}
@keyframes rejectionAlertRing {
  0% {
    transform: scale(0.7);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}
@keyframes rejectionCardGlow {
  0%, 100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
  }
}
@keyframes highestRejectGlow {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.9;
  }
}
@keyframes highestBadgePulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(239, 68, 68, 0.07);
  }
}
@media (max-width: 600px) {
  .reject-row {
    grid-template-columns: 30px minmax(0, 1fr);
    gap: 9px;
  }
  .reject-percent-wrapper {
    grid-column: 2;
    align-items: flex-start;
    margin-top: 3px;
  }
  .rejection-alert-indicator {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .top-rejection-card,
  .reject-row,
  .reject-progress-value,
  .reject-progress-value::after,
  .reject-progress-glow,
  .rejection-alert-dot,
  .rejection-alert-dot::after,
  .highest-rejection-badge {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/ProductionDashboard/ProductionDashboard.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yJACE;EAEF,yBAAA;EACA,8CAAA;AADF;AAGE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AAHF;AAKE;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,cAAA;EACA,+CAAA;AAHN;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;AALF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AALJ;AAQE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;AASE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAPJ;AAUE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAdF;AAgBE;EACE,iBAAA;AAdJ;;AAmBA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;AAhBF;AAkBE;EACE,YAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAnBF;AAqBE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApBJ;;AAwBA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,oBAAA;AArBF;;AAwBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AArBF;AAuBE;EACE,qBAAA;EACA,mBAAA;EACA,2BAAA;AArBJ;AAwBE;EACE,yCAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,YAAA;EACA,aAAA;AAvBJ;;AA2BA;EACE,WAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAxBF;AA0BE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;AAxBJ;AA0BI;EACE,4BAAA;AAxBN;AA2BI;EACE,4BAAA;AAzBN;AA6BE;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;AA3BJ;AA6BI;EACE,cAAA;EACA,gBAAA;AA3BN;AA+BE;EACE,mBAAA;AA7BJ;;AAiCA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA9BF;AAgCE;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,+BAAA;EACA,sBAAA;AA9BJ;AAiCE;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;AAhCJ;AAkCI;EACE,UAAA;EACA,0BAAA;AAhCN;AAoCE;EACE,cAAA;AAlCJ;AAoCI;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;AAnCN;AAuCE;EACE,cAAA;AArCJ;AAuCI;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;AAtCN;;AA2CA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,4DAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxCF;AA0CE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAxCJ;AA2CE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAzCJ;;AA6CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qDAAA;EACA,cAAA;EACA,6CAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AA1CF;AA4CE;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;AA3CJ;;AA+CA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;AA5CF;AA8CE;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA5CJ;AA+CE;;EAEE,cAAA;AA7CJ;AAgDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/CJ;;AAmDA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAhDF;AAkDE;EACE,qBAAA;EACA,8CAAA;AAhDJ;AAmDE;EACE,iBAAA;EACA,cAAA;AAjDJ;AAoDE;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAlDJ;;AAsDA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAnDF;;AAsDA;EACE,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAnDF;;AAsDA;EACE,iBAAA;EACA,cAAA;EACA,SAAA;AAnDF;;AAsDA;EACE,gBAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAnDF;AAqDE;EACE,gBAAA;EACA,UAAA;EACA,MAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAnDJ;AAsDE;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AApDJ;AAuDE;EACE,mBAAA;AArDJ;AAwDE;EACE,mBAAA;AAtDJ;;AA0DA;EACE,gBAAA;AAvDF;AAyDE;;EAEE,cAAA;AAvDJ;AA0DE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAxDJ;AA2DE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzDJ;;AA6DA;EACE,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA1DF;AA4DE;EACE,mBAAA;EACA,cAAA;AA1DJ;AA6DE;EACE,mBAAA;EACA,cAAA;AA3DJ;AA8DE;EACE,mBAAA;EACA,cAAA;AA5DJ;;AAgEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AA7DF;AA+DE;EACE,cAAA;EACA,eAAA;AA7DJ;AAgEE;EACE,cAAA;EACA,eAAA;AA9DJ;;AAkEA;EACE,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AA/DF;AAiEE;EACE,cAAA;EACA,eAAA;AA/DJ;AAkEE;EACE,cAAA;AAhEJ;AAmEE;EACE,eAAA;AAjEJ;AAoEE;EAGE,cAAA;AApEJ;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qDAAA;AArEF;;AAwEA;EACE;IAAK,yBAAA;EApEL;AACF;AAsEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AApEF;AAsEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AApEJ;AAuEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AArEJ;AAuEI;EACE,aAAA;EACA,mBAAA;AArEN;AAyEE;EACE,cAAA;EACA,eAAA;AAvEJ;;AA2EA;EACE,yBAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,yBAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,yBAAA;EACA,gBAAA;AAxEF;;AA2EA;;EAEE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAxEF;AA0EE;;EACE,eAAA;EACA,cAAA;AAvEJ;AA0EE;;EACE,SAAA;EACA,cAAA;AAvEJ;;AA2EA;EACE;IACE,gDAAA;EAxEF;EA2EA;IACE,0BAAA;EAzEF;AACF;AA4EA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,aAAA;EA1EF;EA4EE;IACE,eAAA;EA1EJ;EA8EA;IACE,0BAAA;EA5EF;EA+EA;IACE,aAAA;IACA,mBAAA;EA7EF;EAgFA;IACE,qBAAA;IACA,UAAA;EA9EF;EAiFA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;EA/EF;EAkFA;;;IAGE,mBAAA;IACA,kBAAA;EAhFF;EAmFA;IACE,oBAAA;IACA,sBAAA;EAjFF;EAoFA;IACE,gBAAA;EAlFF;EAoFE;IACE,gBAAA;EAlFJ;EAsFA;IACE,WAAA;EApFF;EAuFA;IACE,uBAAA;IACA,sBAAA;EArFF;EAuFE;IACE,WAAA;IACA,8BAAA;EArFJ;AACF;AA0FA;EACE,mBAAA;AAxFF;;AA2FA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EAEA,sBAAA;EACA,2CAAA;EACA,6BAAA;EAEA,uEACE;AA3FJ;;AAgGA;EACE,uCAAA;EACA,8CAAA;EACA,wBAAA;AA7FF;;AAgGA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,wFAAA;EAIA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EAEA,oBAAA;AAlGF;;AAqGA;EACE,UAAA;AAlGF;;AAqGA;EACE,qBAAA;EAEA,0BAAA;EACA,wCAAA;EACA,2CAAA;AAnGF;;AAsGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,qBAAA;EACA,0CAAA;EACA,2CAAA;AApGF;;AAuGA;EACE,qBAAA;EAEA,4BAAA;EACA,0CAAA;EACA,2CAAA;AArGF;;AAwGA;EACE,wBAAA;EACA,6CAAA;EACA,2CAAA;EAEA,+BAAA;AAtGF;;AAyGA;EACE,oCAAA;AAtGF;;AAyGA;EACE;IACE,UAAA;IACA,qDAAA;EAtGF;EAyGA;IACE,UAAA;IACA,mDAAA;EAvGF;EA0GA;IACE,UAAA;IACA,4CAAA;EAxGF;AACF;AA2GA;EACE;IACE,UAAA;IACA,4BAAA;EAzGF;EA4GA;IACE,UAAA;IACA,wBAAA;EA1GF;AACF;AA6GA;EACE;IACE,UAAA;IACA,sBAAA;EA3GF;EA8GA;IACE,UAAA;IACA,sBAAA;EA5GF;EA+GA;IACE,UAAA;IACA,mBAAA;EA7GF;AACF;AAgHA;EACE;IACE,UAAA;IACA,2BAAA;EA9GF;EAiHA;IACE,UAAA;IACA,wBAAA;EA/GF;AACF;AAkHA;EACE;IACE,UAAA;IACA,qCAAA;EAhHF;EAmHA;IACE,UAAA;IACA,mCAAA;EAjHF;EAoHA;IACE,UAAA;IACA,6BAAA;EAlHF;AACF;AA2HA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAzHF;AA2HE;EACE,YAAA;EACA,SAAA;AAzHJ;AA4HE;EACE,eAAA;AA1HJ;AA6HE;EACE,SAAA;AA3HJ;;AA+HA;EACE,kBAAA;EAEA,oBAAA;EACA,mBAAA;EAEA,cAAA;EAEA,YAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,oFACE;AAnIJ;AAsIE;EACE,kBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAEA,gBAAA;EAEA,iBAAA;EAEA,SAAA;EACA,kBAAA;EAEA,uBAAA;EAEA,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,gBAAA;EAEA,eAAA;EAEA,mGACE;AA9IN;AAmJI;EACE,cAAA;EACA,kCAAA;AAjJN;AAoJI;EACE,sBAAA;AAlJN;AAqJI;EAKE,cAAA;EAEA,6DAAA;EAIA,8EAAA;AA3JN;AAiJM;EACE,cAAA;AA/IR;AA2JM;EACE,cAAA;AAzJR;;AAoKA;EACE,WAAA;EACA,YAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;AAnKF;AAqKE;EACE,WAAA;EACA,YAAA;EAEA,cAAA;AApKJ;;AA6KA;EACE,qBAAA;EACA,QAAA;AA1KF;AA4KE;EACE,cAAA;EAEA,UAAA;EAEA,8BAAA;EAEA,wBAAA;AA7KJ;AA+KI;EACE,WAAA;AA7KN;AAgLI;EACE,YAAA;AA9KN;AAiLI;EACE,YAAA;AA/KN;;AAyLA;;EAEE,WAAA;EACA,iBAAA;AAtLF;AAwLE;;EACE,cAAA;AArLJ;;AA8LA;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,qFAAA;EAIA,mBAAA;AAlMF;;AA0MA;EACE;IACE,sBAAA;IACA,oBAAA;IAEA,SAAA;EAxMF;EA2MA;IACE,sBAAA;EAzMF;AACF;AA6MA;EACE;IACE,WAAA;EA3MF;EA6ME;IACE,SAAA;EA3MJ;AACF;AAoNA;EACE,WAAA;EAEA,4EAAA;AAnNF;;AA2NA;EACE,aAAA;EAEA,gDAAA;EAEA,QAAA;EAEA,mBAAA;AA3NF;;AA8NA;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,YAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,qDAAA;EAIA,eAAA;EAEA,UAAA;EAEA,2BAAA;EAEA,mFAAA;EAEA,6BAAA;EAEA,mGACE;AA3OJ;AAgPE;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,WAAA;EAEA,WAAA;EAEA,+BAAA;EAEA,aAAA;EAEA,+CACE;AArPN;AAyPE;EACE,2BAAA;EAEA,kEAAA;EAIA,6CACE;AA5PN;AA+PE;EACE,iCAAA;EAEA,iGACE;EAMF,+EACE;AArQN;AAyQI;EACE,WAAA;EACA,UAAA;AAvQN;AA0QI;EACE,8EACE;AAzQR;AA+QE;EACE,cAAA;EAEA,eAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,uBAAA;EAEA,mBAAA;AApRJ;AAuRE;EACE,oBAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,0BAAA;EAEA,mEACE;EAIF,eAAA;EACA,gBAAA;AA9RJ;;AAuSA;EACE,aAAA;EACA,mBAAA;EAEA,QAAA;AArSF;;AAwSA;EACE,UAAA;EACA,WAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,+BAAA;EAEA,gCAAA;AAzSF;;AA4SA;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;AA1SF;;AAkTA;EACE,aAAA;EAEA,gEACE;EAEF,mBAAA;EAEA,QAAA;EAEA,iBAAA;AApTF;;AA4TA;EACE,YAAA;AAzTF;AA2TE;EACE,cAAA;AAzTJ;;AAkUA;EACE,kBAAA;EAEA,kBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,iGACE;EAMF,6CACE;EAEF,iFAAA;AA3UF;AA6UE;EACE,kBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;AA7UJ;;AAsVA;EACE,oBAAA;EACA,mBAAA;EAEA,QAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,0BAAA;EAEA,oEACE;EAIF,cAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;AA9VF;;AAiWA;EACE,UAAA;EACA,WAAA;EAEA,kBAAA;EAEA,+BAAA;EAEA,4DAAA;AAjWF;;AAyWA;EACE,cAAA;EAEA,gBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,iBAAA;EAEA,wBAAA;EAEA,uBAAA;EAEA,mBAAA;AA7WF;;AAqXA;EACE,aAAA;EACA,sBAAA;EAEA,QAAA;EAEA,eAAA;AApXF;AAsXE;EACE,0BAAA;EAEA,eAAA;EACA,gBAAA;AArXJ;AAwXE;EACE,cAAA;EAEA,cAAA;EACA,gBAAA;AAvXJ;;AAgYA;EACE,aAAA;EACA,sBAAA;EAEA,QAAA;EAEA,gBAAA;EAEA,iBAAA;EAEA,8BAAA;AAjYF;AAmYE;EACE,cAAA;EAEA,cAAA;EACA,gBAAA;AAlYJ;AAqYE;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;AApYJ;;AA6YA;EACE,aAAA;EACA,sBAAA;EAEA,QAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,8CACE;AAlZJ;AAoZE;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;AAnZJ;AAsZE;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;AArZJ;;AAyZA;EACE,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;AAzZF;;AA4ZA;EACE,UAAA;EACA,WAAA;EAEA,cAAA;EAEA,kBAAA;AA3ZF;;AAmaA;EACE;IACE,UAAA;IAEA,uCAAA;EAjaF;EAoaA;IACE,UAAA;IAEA,iCAAA;EAnaF;AACF;AAsaA;EACE;IACE,UAAA;IAEA,2BAAA;EAraF;EAwaA;IACE,UAAA;IAEA,wBAAA;EAvaF;AACF;AA0aA;EACE;IACE,UAAA;IAEA,2BAAA;EAzaF;EA4aA;IACE,UAAA;IAEA,wBAAA;EA3aF;AACF;AA8aA;EAEE;IAEE,mBAAA;IAEA,UAAA;EA/aF;EAkbA;IACE,sBAAA;IAEA,aAAA;EAjbF;AACF;AAybA;EACE;IACE,0BAAA;EAvbF;EA0bA;IACE,iBAAA;EAxbF;AACF;AA2bA;EACE;IACE,0BAAA;EAzbF;EA4bA;IACE,gBAAA;EA1bF;AACF;AA6bA;EAEE;;;;IAIE,eAAA;EA5bF;AACF;AAocA;EACE,kBAAA;EAEA,gBAAA;EAEA,wEAAA;AApcF;AAscE;EACE,kBAAA;EAEA,UAAA;EACA,YAAA;EAEA,YAAA;EACA,aAAA;EAEA,WAAA;EAEA,kBAAA;EAEA,4GACE;EAKF,oBAAA;EAEA,oDAAA;AA/cJ;;AAwdA;EACE,oBAAA;EACA,mBAAA;EAEA,QAAA;EAEA,gBAAA;EAEA,yCAAA;EAEA,oBAAA;EAEA,cAAA;EAEA,mCAAA;EAEA,eAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;AA9dF;;AAieA;EACE,kBAAA;EAEA,UAAA;EACA,WAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,wDAAA;AAneF;AAqeE;EACE,kBAAA;EAEA,WAAA;EAEA,WAAA;EAEA,wCAAA;EAEA,kBAAA;EAEA,oDAAA;AAxeJ;;AAifA;EACE,aAAA;EACA,sBAAA;EAEA,SAAA;AA/eF;;AAufA;EACE,kBAAA;EAEA,aAAA;EAEA,+CAAA;EAEA,mBAAA;EAEA,SAAA;EAEA,YAAA;EAEA,qBAAA;EAEA,gBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,6DACE;EAIF,8CACE;EAEF,UAAA;EAEA,wCAAA;EAEA,2EAAA;EAEA,oCAAA;EAEA,uGACE;AAzgBJ;AA8gBE;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EAEA,UAAA;EACA,YAAA;EAEA,WAAA;EAEA,qDACE;EAIF,YAAA;EAEA,gDACE;AAthBN;AA0hBE;EACE,wCAAA;EAEA,oCAAA;EAEA,+EACE;EAIF,kFACE;AA/hBN;AAkiBI;EACE,UAAA;EACA,UAAA;AAhiBN;AAmiBI;EACE,oCAAA;AAjiBN;AAoiBI;EACE,sBAAA;AAliBN;AAsiBE;EACE,qCAAA;EAEA,uEACE;EAIF,8CACE;AA1iBN;AA4iBI;EACE,kBAAA;EAEA,UAAA;EACA,YAAA;EAEA,YAAA;EACA,aAAA;EAEA,WAAA;EAEA,kBAAA;EAEA,6EACE;EAIF,oDAAA;AAnjBN;;AA6jBA;EACE,kBAAA;EACA,UAAA;EAEA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;EAEA,yCAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,kFACE;EAIF,8CACE;EAEF,eAAA;EACA,gBAAA;EAEA,gCAAA;AAxkBF;;AAglBA;EACE,kBAAA;EACA,UAAA;EAEA,YAAA;AA9kBF;;AAilBA;EACE,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,YAAA;AAhlBF;AAklBE;EACE,gBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,uBAAA;EAEA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAplBJ;;AAwlBA;EACE,oBAAA;EACA,mBAAA;EAEA,cAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,cAAA;EAEA,mCAAA;EAEA,cAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;EAEA,oDAAA;AA9lBF;;AAimBA;EACE,cAAA;EAEA,eAAA;EAEA,cAAA;EAEA,cAAA;EACA,gBAAA;AAjmBF;AAmmBE;EACE,cAAA;EAEA,gBAAA;AAlmBJ;;AA2mBA;EACE,kBAAA;EAEA,WAAA;EACA,WAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,mBAAA;EAEA,kDACE;AA/mBJ;;AAknBA;EACE,kBAAA;EAEA,6BAAA;EACA,YAAA;EAEA,gBAAA;EAEA,sBAAA;EAEA,4DACE;EAIF,6BAAA;EAEA,yEAAA;EAEA,kDAAA;AAznBF;AA2nBE;EACE,kBAAA;EAEA,MAAA;EACA,UAAA;EAEA,UAAA;EACA,YAAA;EAEA,WAAA;EAEA,uFACE;EAKF,wBAAA;EAEA,6DAAA;EAEA,iDAAA;AApoBJ;;AAwoBA;EACE,kBAAA;EAEA,QAAA;EACA,QAAA;EAEA,UAAA;EACA,WAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,8EACE;EAGF,YAAA;EAEA,+BAAA;EAEA,8DAAA;AA/oBF;;AAupBA;EACE,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,qBAAA;EAEA,QAAA;EAEA,eAAA;AAvpBF;AAypBE;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;AA1pBJ;;AA8pBA;EACE,oBAAA;EACA,qBAAA;EAEA,gBAAA;EAEA,yCAAA;EAEA,kBAAA;EAEA,cAAA;EAEA,2EACE;EAIF,8CACE;EAEF,eAAA;EACA,gBAAA;EAEA,cAAA;EAEA,wBAAA;EAEA,gCAAA;AAzqBF;AA2qBE;EACE,gBAAA;EAEA,cAAA;EACA,gBAAA;AA1qBJ;;AAmrBA;EACE;IACE,UAAA;IAEA,uCAAA;EAjrBF;EAorBA;IACE,UAAA;IAEA,iCAAA;EAnrBF;AACF;AAsrBA;EACE;IACE,UAAA;IAEA,wCAAA;EArrBF;EAwrBA;IACE,UAAA;IAEA,iCAAA;EAvrBF;AACF;AA0rBA;EACE;IACE,oBAAA;EAxrBF;EA2rBA;IACE,oBAAA;EAzrBF;AACF;AA4rBA;EACE;IACE,UAAA;EA1rBF;EA6rBA;IAEE,UAAA;EA5rBF;AACF;AA+rBA;EAEE;IAEE,wCAAA;IAEA,aAAA;EAhsBF;EAmsBA;IACE,2CAAA;IAEA,UAAA;EAlsBF;AACF;AAqsBA;EAEE;IAEE,mBAAA;IAEA,UAAA;EAtsBF;EAysBA;IACE,sBAAA;IAEA,YAAA;EAxsBF;AACF;AA2sBA;EACE;IACE,qBAAA;IAEA,YAAA;EA1sBF;EA6sBA;IACE,qBAAA;IAEA,UAAA;EA5sBF;AACF;AA+sBA;EAEE;IAEE,mBAAA;IAEA,YAAA;EAhtBF;EAmtBA;IACE,sBAAA;IAEA,UAAA;EAltBF;AACF;AAqtBA;EAEE;IAEE,mBAAA;IAEA,YAAA;EAttBF;EAytBA;IACE,qBAAA;IAEA,YAAA;EAxtBF;AACF;AA2tBA;EAEE;IAEE,wCACE;EA5tBJ;EA+tBA;IACE,6CACE;EA9tBJ;AACF;AAsuBA;EACE;IACE,0CAAA;IAEA,QAAA;EAruBF;EAwuBA;IACE,cAAA;IAEA,uBAAA;IAEA,eAAA;EAxuBF;EA2uBA;IACE,aAAA;EAzuBF;AACF;AAivBA;EAEE;;;;;;;;IAQE,eAAA;EAhvBF;AACF","sourcesContent":[".dashboard-kpi-image {\n  width: 54px;\n  height: 50px;\n  margin-right: 8px;\n  object-fit: contain;\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.production-dashboard-section {\n  margin-top: 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.production-dashboard-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 24px;\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at top left, rgba(37, 99, 235, 0.18), transparent 34%),\n    linear-gradient(135deg, #ffffff 0%, #f8fbff 52%, #eef6ff 100%);\n  border: 1px solid #e5edf8;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.07);\n\n  h2 {\n    margin: 6px 0 8px;\n    color: #0f172a;\n    font-size: 24px;\n    font-weight: 700;\n    letter-spacing: -0.04em;\n  }\n\n  p {\n    margin: 0;\n    max-width: 760px;\n    color: #64748b;\n    font-size: 14px;\n    line-height: 1.6;\n  }\n}\n\n.section-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.production-actions {\n  display: inline-flex;\n  padding: 5px;\n  border-radius: 999px;\n  background: #eef2ff;\n  border: 1px solid #dbe3f3;\n\n  button {\n    border: 0;\n    background: transparent;\n    color: #475569;\n    padding: 9px 16px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 800;\n    cursor: pointer;\n    transition: 0.2s ease;\n\n    &.active {\n      background: #2563eb;\n      color: #ffffff;\n      box-shadow: 0 10px 20px rgba(37, 99, 235, 0.25);\n    }\n  }\n}\n\n.production-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.production-kpi-card {\n  position: relative;\n  overflow: hidden;\n  padding: 8px 20px;\n  border-radius: 22px;\n  background: #ffffff;\n  border: 1px solid #e8edf7;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.06);\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    width: 120px;\n    height: 120px;\n    right: -48px;\n    top: -48px;\n    border-radius: 50%;\n    opacity: 0.16;\n  }\n\n  span {\n    display: block;\n    color: #64748b;\n    font-size: 13px;\n    font-weight: 680;\n  }\n\n  strong {\n    display: block;\n    color: #0f172a;\n    font-size: 24px;\n    font-weight: 600;\n    letter-spacing: 0.6px;\n  }\n\n  small {\n    display: block;\n    margin-top: 4px;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 1.0px;\n  }\n\n  &.primary::after {\n    background: #2563eb;\n  }\n\n  &.success::after {\n    background: #16a34a;\n  }\n\n  &.danger::after {\n    background: #ef4444;\n  }\n\n  &.warning::after {\n    background: #f59e0b;\n  }\n\n  &.purple::after {\n    background: #7c3aed;\n  }\n}\n\n.production-chart-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) minmax(320px, 0.8fr);\n  gap: 18px;\n\n  > :only-child {\n    grid-column: 1 / -1;\n  }\n\n}\n\n.production-dashboard-card {\n  background: #ffffff;\n  border: 1px solid #e8edf7;\n  border-radius: 24px;\n  padding: 22px;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);\n\n  &.large {\n    min-width: 0;\n  }\n}\n\n.card-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 16px;\n\n  h3 {\n    margin: 0;\n    color: #0f172a;\n    font-size: 20px;\n    font-weight: 640;\n    letter-spacing: -0.03em;\n  }\n\n  p {\n    margin: 5px 0 0;\n    color: #64748b;\n    font-size: 13px;\n  }\n}\n\n.reject-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.reject-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px;\n  border-radius: 18px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n\n  strong {\n    display: block;\n    color: #0f172a;\n    font-size: 13px;\n    font-weight: 850;\n  }\n\n  span {\n    display: block;\n    margin-top: 4px;\n    color: #64748b;\n    font-size: 12px;\n  }\n}\n\n.reject-percent {\n  min-width: 58px;\n  text-align: center;\n  padding: 7px 10px;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #b91c1c;\n  font-size: 13px;\n  font-weight: 900;\n}\n\n.table-card {\n  padding-bottom: 16px;\n}\n\n.production-summary-download {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 9px 14px;\n  border: 1px solid #b7ddc5;\n  border-radius: 10px;\n  background: #ecfdf3;\n  color: #087443;\n  font-size: 13px;\n  font-weight: 800;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: 160ms ease;\n\n  &:hover:not(:disabled) {\n    border-color: #75c493;\n    background: #dcfce7;\n    transform: translateY(-1px);\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(34, 197, 94, 0.2);\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    cursor: wait;\n    opacity: 0.65;\n  }\n}\n\n.production-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.production-table {\n  width: 100%;\n  min-width: 960px;\n  border-collapse: collapse;\n\n  th {\n    text-align: left;\n    padding: 13px 14px;\n    background: #f8fafc;\n    color: #475569;\n    font-size: 12px;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    border-bottom: 1px solid #e8edf7;\n\n    &:first-child {\n      border-radius: 14px 0 0 14px;\n    }\n\n    &:last-child {\n      border-radius: 0 14px 14px 0;\n    }\n  }\n\n  td {\n    padding: 14px;\n    color: #334155;\n    font-size: 14px;\n    border-bottom: 1px solid #eef2f7;\n    white-space: nowrap;\n    letter-spacing: 0.8px;\n\n    strong {\n      color: #0f172a;\n      font-weight: 780;\n    }\n  }\n\n  tr:hover td {\n    background: #f8fbff;\n  }\n}\n\n.production-table__detail-link {\n  display: inline-flex;\n  min-width: 64px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 5px 8px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  background: transparent;\n  color: #25415f;\n  font: inherit;\n  font-weight: 800;\n  cursor: pointer;\n  transition: 160ms ease;\n\n  i {\n    color: #8aa0b8;\n    font-size: 10px;\n    opacity: 0;\n    transform: translate(-2px, 2px);\n    transition: 160ms ease;\n  }\n\n  &:hover,\n  &:focus-visible {\n    border-color: #c8d9ed;\n    background: #edf5ff;\n    color: #075bbd;\n    outline: none;\n\n    i {\n      opacity: 1;\n      transform: translate(0, 0);\n    }\n  }\n\n  &.is-reject {\n    color: #d92d20;\n\n    &:hover,\n    &:focus-visible {\n      border-color: #fecaca;\n      background: #fff1f0;\n      color: #b42318;\n    }\n  }\n\n  &.is-rework {\n    color: #c56a00;\n\n    &:hover,\n    &:focus-visible {\n      border-color: #fed7aa;\n      background: #fff7e8;\n      color: #9a4d00;\n    }\n  }\n}\n\n.department-detail-modal {\n  position: fixed;\n  z-index: 2200;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  background: rgba(8, 24, 43, 0.56);\n  backdrop-filter: blur(3px);\n}\n\n.department-detail-modal__dialog {\n  display: flex;\n  width: min(1440px, 96vw);\n  max-height: 90vh;\n  overflow: hidden;\n  flex-direction: column;\n  border: 1px solid #d8e3f0;\n  border-radius: 18px;\n  background: #ffffff;\n  box-shadow: 0 28px 80px rgba(15, 36, 61, 0.3);\n}\n\n.department-detail-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 22px 24px 19px;\n  border-bottom: 1px solid #e3eaf2;\n  background: linear-gradient(135deg, #f7fbff 0%, #ffffff 65%);\n}\n\n.department-detail-modal__heading {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  h2 {\n    margin: 3px 0 0;\n    color: #102a45;\n    font-size: 21px;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #667b93;\n    font-size: 12px;\n  }\n}\n\n.department-detail-modal__eyebrow {\n  color: #0872ce;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.department-detail-modal__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: linear-gradient(145deg, #087de0, #0757b4);\n  color: #ffffff;\n  box-shadow: 0 7px 17px rgba(7, 91, 189, 0.25);\n  font-size: 18px;\n}\n\n.department-detail-modal__close {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d9e3ee;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #4b6179;\n  cursor: pointer;\n  transition: 150ms ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: #b9cbe0;\n    background: #f2f7fc;\n    color: #102a45;\n    outline: none;\n  }\n}\n\n.department-detail-modal__toolbar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e7edf4;\n  background: #fbfdff;\n}\n\n.department-detail-modal__stats {\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n\n  > div {\n    min-width: 145px;\n    padding: 9px 12px;\n    border: 1px solid #dce6f0;\n    border-radius: 10px;\n    background: #ffffff;\n  }\n\n  span,\n  strong {\n    display: block;\n  }\n\n  span {\n    color: #73869c;\n    font-size: 10px;\n    font-weight: 750;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n\n  strong {\n    margin-top: 4px;\n    color: #15395f;\n    font-size: 14px;\n    font-weight: 850;\n  }\n}\n\n.department-detail-modal__search {\n  display: flex;\n  width: min(430px, 100%);\n  height: 40px;\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid #cdd9e7;\n  border-radius: 9px;\n  background: #ffffff;\n  transition: 150ms ease;\n\n  &:focus-within {\n    border-color: #2483d5;\n    box-shadow: 0 0 0 3px rgba(36, 131, 213, 0.11);\n  }\n\n  > i {\n    margin-left: 12px;\n    color: #7890a8;\n  }\n\n  input {\n    min-width: 0;\n    height: 100%;\n    flex: 1;\n    padding: 0 10px;\n    border: 0;\n    outline: 0;\n    color: #203b58;\n    font-size: 12px;\n  }\n}\n\n.department-detail-modal__clear {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #7a8fa5;\n  cursor: pointer;\n}\n\n.department-detail-modal__search-button {\n  align-self: stretch;\n  padding: 0 16px;\n  border: 0;\n  background: #0875cf;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.department-detail-modal__body {\n  min-height: 260px;\n  overflow: auto;\n  flex: 1;\n}\n\n.department-detail-modal__table-wrapper {\n  min-width: 980px;\n}\n\n.department-detail-modal__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n\n  th {\n    position: sticky;\n    z-index: 2;\n    top: 0;\n    padding: 12px 14px;\n    border-bottom: 1px solid #cfdce9;\n    background: #eaf2fa;\n    color: #244361;\n    font-size: 11px;\n    font-weight: 850;\n    letter-spacing: 0.035em;\n    text-align: left;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  td {\n    padding: 11px 14px;\n    border-bottom: 1px solid #e8eef5;\n    background: #ffffff;\n    color: #35516e;\n    font-size: 12px;\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n\n  tbody tr:nth-child(even) td {\n    background: #fbfdff;\n  }\n\n  tbody tr:hover td {\n    background: #f2f7fd;\n  }\n}\n\n.department-detail-modal__identity {\n  min-width: 140px;\n\n  strong,\n  span {\n    display: block;\n  }\n\n  strong {\n    overflow: hidden;\n    max-width: 260px;\n    color: #173651;\n    font-size: 12px;\n    font-weight: 800;\n    text-overflow: ellipsis;\n  }\n\n  span {\n    margin-top: 3px;\n    color: #7a8da2;\n    font-size: 10px;\n    font-weight: 650;\n  }\n}\n\n.department-detail-modal__quantity {\n  display: inline-flex;\n  min-width: 62px;\n  justify-content: center;\n  padding: 5px 8px;\n  border-radius: 7px;\n  background: #e9f1fb;\n  color: #1c4f80;\n  font-weight: 800;\n\n  &.is-ok {\n    background: #e2f5e8;\n    color: #167441;\n  }\n\n  &.is-reject {\n    background: #ffebe9;\n    color: #b42318;\n  }\n\n  &.is-rework {\n    background: #fff2d8;\n    color: #9a5c00;\n  }\n}\n\n.department-detail-modal__count {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n\n  strong {\n    color: #193c5f;\n    font-size: 13px;\n  }\n\n  span {\n    color: #8293a6;\n    font-size: 10px;\n  }\n}\n\n.department-detail-modal__jobcard {\n  display: inline-flex;\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #e3ecf9;\n  color: #174a82;\n  font-weight: 800;\n}\n\n.department-detail-modal__state {\n  display: flex;\n  min-height: 270px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 9px;\n  color: #657a90;\n\n  > i {\n    color: #8ca2b9;\n    font-size: 28px;\n  }\n\n  strong {\n    color: #294866;\n  }\n\n  span {\n    font-size: 12px;\n  }\n\n  &.is-error,\n  &.is-error i,\n  &.is-error strong {\n    color: #b42318;\n  }\n}\n\n.department-detail-modal__spinner {\n  width: 28px;\n  height: 28px;\n  border: 3px solid #dce8f3;\n  border-top-color: #0875cf;\n  border-radius: 50%;\n  animation: departmentDetailSpin 0.75s linear infinite;\n}\n\n@keyframes departmentDetailSpin {\n  to { transform: rotate(360deg); }\n}\n\n.department-detail-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 13px 24px;\n  border-top: 1px solid #dfe8f1;\n  background: #f8fbfe;\n  color: #647b92;\n  font-size: 11px;\n\n  > div {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px 10px;\n    border: 1px solid #cfdae6;\n    border-radius: 7px;\n    background: #ffffff;\n    color: #315371;\n    font-size: 11px;\n    font-weight: 750;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n  }\n\n  strong {\n    color: #2b4965;\n    font-size: 11px;\n  }\n}\n\n.success-text {\n  color: #15803d !important;\n  font-weight: 800;\n}\n\n.danger-text {\n  color: #dc2626 !important;\n  font-weight: 800;\n}\n\n.warning-text {\n  color: #d97706 !important;\n  font-weight: 800;\n}\n\n.loading-card,\n.empty-card {\n  min-height: 160px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  h3 {\n    margin: 0 0 8px;\n    color: #0f172a;\n  }\n\n  p {\n    margin: 0;\n    color: #64748b;\n  }\n}\n\n@media (max-width: 1200px) {\n  .production-kpi-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .production-chart-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .production-dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n\n    h2 {\n      font-size: 21px;\n    }\n  }\n\n  .production-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .production-dashboard-card {\n    padding: 18px;\n    border-radius: 20px;\n  }\n\n  .department-detail-modal {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .department-detail-modal__dialog {\n    width: 100%;\n    max-height: 94vh;\n    border-radius: 18px 18px 0 0;\n  }\n\n  .department-detail-modal__header,\n  .department-detail-modal__toolbar,\n  .department-detail-modal__footer {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .department-detail-modal__toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .department-detail-modal__stats {\n    overflow-x: auto;\n\n    > div {\n      min-width: 135px;\n    }\n  }\n\n  .department-detail-modal__search {\n    width: 100%;\n  }\n\n  .department-detail-modal__footer {\n    align-items: flex-start;\n    flex-direction: column;\n\n    > div {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n}\n\n\n.animated-kpi-grid {\n  perspective: 1000px;\n}\n\n.animated-kpi-card {\n  position: relative;\n  overflow: hidden;\n  opacity: 0;\n\n  /* Slower card entry */\n  animation: kpiCardEntry 1.25s ease forwards;\n  animation-delay: var(--delay);\n\n  transition:\n    transform 0.6s ease,\n    box-shadow 0.6s ease,\n    filter 0.6s ease;\n}\n\n.animated-kpi-card:hover {\n  transform: translateY(-8px) scale(1.03);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);\n  filter: brightness(1.04);\n}\n\n.animated-kpi-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -75%;\n  width: 55%;\n  height: 100%;\n  background: linear-gradient(120deg,\n      transparent,\n      rgba(255, 255, 255, 0.35),\n      transparent);\n  transform: skewX(-20deg);\n\n  /* Slower shine effect */\n  transition: left 1.3s ease;\n\n  pointer-events: none;\n}\n\n.animated-kpi-card:hover::before {\n  left: 130%;\n}\n\n.animated-kpi-card span {\n  display: inline-block;\n\n  /* Slower text animation */\n  animation: kpiTextSlide 1s ease forwards;\n  animation-delay: calc(var(--delay) + 250ms);\n}\n\n.animated-kpi-card strong {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  /* Slower value pop */\n  animation: kpiValuePop 1.15s ease forwards;\n  animation-delay: calc(var(--delay) + 350ms);\n}\n\n.animated-kpi-card small {\n  display: inline-block;\n\n  /* Slower bottom text fade */\n  animation: kpiSmallFade 1.1s ease forwards;\n  animation-delay: calc(var(--delay) + 450ms);\n}\n\n.animated-kpi-card .dashboard-kpi-image {\n  /* Slower image bounce */\n  animation: kpiImageBounce 1.45s ease forwards;\n  animation-delay: calc(var(--delay) + 300ms);\n\n  transition: transform 0.6s ease;\n}\n\n.animated-kpi-card:hover .dashboard-kpi-image {\n  transform: rotate(-6deg) scale(1.15);\n}\n\n@keyframes kpiCardEntry {\n  0% {\n    opacity: 0;\n    transform: translateY(28px) scale(0.94) rotateX(8deg);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translateY(-3px) scale(1.015) rotateX(0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1) rotateX(0);\n  }\n}\n\n@keyframes kpiTextSlide {\n  0% {\n    opacity: 0;\n    transform: translateX(-14px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes kpiValuePop {\n  0% {\n    opacity: 0;\n    transform: scale(0.86);\n  }\n\n  65% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes kpiSmallFade {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes kpiImageBounce {\n  0% {\n    opacity: 0;\n    transform: scale(0.55) rotate(-12deg);\n  }\n\n  55% {\n    opacity: 1;\n    transform: scale(1.16) rotate(5deg);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1) rotate(0);\n  }\n}\n\n\n\n// ============================================================\n// Chart View Switch - Column / Area\n// ============================================================\n\n.card-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n\n  >div:first-child {\n    min-width: 0;\n    flex: 1;\n  }\n\n  h3 {\n    margin: 0 0 5px;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n.chart-view-switch {\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n\n  flex-shrink: 0;\n\n  padding: 4px;\n\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n\n  background: #f8fafc;\n\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    inset 0 1px 2px rgba(15, 23, 42, 0.02);\n\n  button {\n    position: relative;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n\n    min-height: 32px;\n\n    padding: 6px 10px;\n\n    border: 0;\n    border-radius: 8px;\n\n    background: transparent;\n\n    color: #64748b;\n\n    font-family: inherit;\n    font-size: 11px;\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition:\n      background-color 0.2s ease,\n      color 0.2s ease,\n      box-shadow 0.2s ease,\n      transform 0.15s ease;\n\n    &:hover:not(.active) {\n      color: #053c83;\n      background: rgba(5, 60, 131, 0.06);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n\n    &.active {\n      span {\n        color: #ffffff;\n      }\n\n      color: #ffffff;\n\n      background: linear-gradient(135deg,\n        #053c83 0%,\n        #2f539d 100%);\n\n      box-shadow: 0 4px 10px rgba(5, 60, 131, 0.2),\n      0 1px 2px rgba(5, 60, 131, 0.15);\n\n      .chart-switch-icon {\n        color: #ffffff;\n      }\n    }\n  }\n}\n\n\n// ============================================================\n// Shared Chart Switch Icon\n// ============================================================\n\n.chart-switch-icon {\n  width: 16px;\n  height: 16px;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  color: currentColor;\n\n  svg {\n    width: 16px;\n    height: 16px;\n\n    display: block;\n  }\n}\n\n\n// ============================================================\n// Column Chart Icon\n// ============================================================\n\n.column-icon {\n  align-items: flex-end;\n  gap: 2px;\n\n  i {\n    display: block;\n\n    width: 3px;\n\n    border-radius: 2px 2px 1px 1px;\n\n    background: currentColor;\n\n    &:nth-child(1) {\n      height: 7px;\n    }\n\n    &:nth-child(2) {\n      height: 13px;\n    }\n\n    &:nth-child(3) {\n      height: 10px;\n    }\n  }\n}\n\n\n// ============================================================\n// Chart Wrappers\n// ============================================================\n\n.production-trend-chart-wrapper,\n.department-quality-chart-wrapper {\n  width: 100%;\n  min-height: 390px;\n\n  .apexcharts-canvas {\n    margin: 0 auto;\n  }\n}\n\n\n// ============================================================\n// Empty State\n// ============================================================\n\n.chart-empty-state {\n  min-height: 390px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: #94a3b8;\n\n  font-size: 13px;\n  font-weight: 600;\n\n  background: linear-gradient(180deg,\n      rgba(248, 250, 252, 0.6),\n      rgba(255, 255, 255, 0));\n\n  border-radius: 12px;\n}\n\n\n// ============================================================\n// Responsive\n// ============================================================\n\n@media (max-width: 768px) {\n  .card-title-row {\n    flex-direction: column;\n    align-items: stretch;\n\n    gap: 12px;\n  }\n\n  .chart-view-switch {\n    align-self: flex-start;\n  }\n}\n\n\n@media (max-width: 480px) {\n  .chart-view-switch {\n    width: 100%;\n\n    button {\n      flex: 1;\n    }\n  }\n}\n\n\n// ============================================================\n// Production Mix Focus Chart\n// ============================================================\n\n.production-mix-focus {\n  width: 100%;\n\n  animation: productionMixFocusReveal 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n\n// ============================================================\n// Clickable Metric Selector\n// ============================================================\n\n.production-mix-selector {\n  display: grid;\n\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n\n  gap: 8px;\n\n  margin-bottom: 12px;\n}\n\n.production-mix-selector-item {\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  min-width: 0;\n\n  padding: 11px 12px;\n\n  overflow: hidden;\n\n  border: 1px solid #e2e8f0;\n\n  border-radius: 12px;\n\n  background: linear-gradient(145deg,\n      #ffffff,\n      #f8fafc);\n\n  cursor: pointer;\n\n  opacity: 0;\n\n  transform: translateY(10px);\n\n  animation: productionMixSelectorReveal 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n\n  animation-delay: var(--delay);\n\n  transition:\n    transform 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    background 0.2s ease;\n\n  &::before {\n    position: absolute;\n\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 3px;\n\n    content: \"\";\n\n    background: var(--metric-color);\n\n    opacity: 0.45;\n\n    transition:\n      height 0.2s ease,\n      opacity 0.2s ease;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n\n    border-color: color-mix(in srgb,\n        var(--metric-color) 35%,\n        #e2e8f0);\n\n    box-shadow:\n      0 8px 22px rgba(15, 23, 42, 0.08);\n  }\n\n  &.active {\n    border-color: var(--metric-color);\n\n    background:\n      linear-gradient(145deg,\n        color-mix(in srgb,\n          var(--metric-color) 7%,\n          #ffffff),\n        #ffffff);\n\n    box-shadow:\n      0 7px 20px color-mix(in srgb,\n        var(--metric-color) 14%,\n        transparent);\n\n    &::before {\n      height: 4px;\n      opacity: 1;\n    }\n\n    .production-mix-selector-dot {\n      box-shadow:\n        0 0 0 4px color-mix(in srgb,\n          var(--metric-color) 15%,\n          transparent);\n    }\n  }\n\n  >strong {\n    display: block;\n\n    max-width: 100%;\n\n    margin-top: 8px;\n\n    overflow: hidden;\n\n    color: #0f172a;\n\n    font-size: 15px;\n    font-weight: 800;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n  }\n\n  >small {\n    display: inline-flex;\n\n    margin-top: 5px;\n\n    padding: 3px 7px;\n\n    border-radius: 999px;\n\n    color: var(--metric-color);\n\n    background:\n      color-mix(in srgb,\n        var(--metric-color) 9%,\n        transparent);\n\n    font-size: 10px;\n    font-weight: 800;\n  }\n}\n\n\n// ============================================================\n// Selector Header\n// ============================================================\n\n.production-mix-selector-top {\n  display: flex;\n  align-items: center;\n\n  gap: 7px;\n}\n\n.production-mix-selector-dot {\n  width: 8px;\n  height: 8px;\n\n  flex-shrink: 0;\n\n  border-radius: 50%;\n\n  background: var(--metric-color);\n\n  transition: box-shadow 0.2s ease;\n}\n\n.production-mix-selector-label {\n  color: #64748b;\n\n  font-size: 11px;\n  font-weight: 700;\n}\n\n\n// ============================================================\n// Focus Content\n// ============================================================\n\n.production-focus-content {\n  display: grid;\n\n  grid-template-columns:\n    minmax(240px, 1.2fr) minmax(150px, 0.8fr);\n\n  align-items: center;\n\n  gap: 5px;\n\n  min-height: 330px;\n}\n\n\n// ============================================================\n// Radial Chart\n// ============================================================\n\n.production-focus-chart {\n  min-width: 0;\n\n  .apexcharts-canvas {\n    margin: 0 auto;\n  }\n}\n\n\n// ============================================================\n// Selected Metric Details\n// ============================================================\n\n.production-focus-details {\n  position: relative;\n\n  padding: 18px 16px;\n\n  border: 1px solid #e8edf5;\n\n  border-radius: 15px;\n\n  background:\n    linear-gradient(145deg,\n      color-mix(in srgb,\n        var(--metric-color) 5%,\n        #ffffff),\n      #ffffff);\n\n  box-shadow:\n    0 8px 24px rgba(15, 23, 42, 0.05);\n\n  animation: productionFocusDetailsReveal 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n\n  h4 {\n    margin: 14px 0 4px;\n\n    color: #64748b;\n\n    font-size: 15px;\n    font-weight: 660;\n  }\n}\n\n\n// ============================================================\n// Selected Badge\n// ============================================================\n\n.production-focus-badge {\n  display: inline-flex;\n  align-items: center;\n\n  gap: 6px;\n\n  padding: 5px 8px;\n\n  border-radius: 999px;\n\n  color: var(--metric-color);\n\n  background:\n    color-mix(in srgb,\n      var(--metric-color) 10%,\n      transparent);\n\n  font-size: 9px;\n  font-weight: 800;\n\n  letter-spacing: 0.03em;\n\n  text-transform: uppercase;\n}\n\n.production-focus-badge-dot {\n  width: 6px;\n  height: 6px;\n\n  border-radius: 50%;\n\n  background: var(--metric-color);\n\n  animation: productionFocusDotPulse 1.8s ease-in-out infinite;\n}\n\n\n// ============================================================\n// Main Value\n// ============================================================\n\n.production-focus-main-value {\n  display: block;\n\n  overflow: hidden;\n\n  color: #0f172a;\n\n  font-size: 25px;\n  font-weight: 900;\n\n  line-height: 1.15;\n\n  letter-spacing: -0.035em;\n\n  text-overflow: ellipsis;\n\n  white-space: nowrap;\n}\n\n\n// ============================================================\n// Percentage\n// ============================================================\n\n.production-focus-percentage-row {\n  display: flex;\n  flex-direction: column;\n\n  gap: 2px;\n\n  margin-top: 9px;\n\n  >span {\n    color: var(--metric-color);\n\n    font-size: 17px;\n    font-weight: 900;\n  }\n\n  >small {\n    color: #94a3b8;\n\n    font-size: 9px;\n    font-weight: 600;\n  }\n}\n\n\n// ============================================================\n// Total Produced\n// ============================================================\n\n.production-focus-total {\n  display: flex;\n  flex-direction: column;\n\n  gap: 3px;\n\n  margin-top: 16px;\n\n  padding-top: 12px;\n\n  border-top: 1px dashed #dbe3ec;\n\n  >span {\n    color: #94a3b8;\n\n    font-size: 9px;\n    font-weight: 600;\n  }\n\n  >strong {\n    color: #334155;\n\n    font-size: 14px;\n    font-weight: 800;\n  }\n}\n\n\n// ============================================================\n// Tooltip\n// ============================================================\n\n.production-focus-tooltip {\n  display: flex;\n  flex-direction: column;\n\n  gap: 5px;\n\n  min-width: 160px;\n\n  padding: 11px 13px;\n\n  border: 1px solid #e2e8f0;\n\n  border-radius: 10px;\n\n  background: #ffffff;\n\n  box-shadow:\n    0 14px 35px rgba(15, 23, 42, 0.14);\n\n  strong {\n    color: #0f172a;\n\n    font-size: 17px;\n    font-weight: 800;\n  }\n\n  small {\n    color: #64748b;\n\n    font-size: 10px;\n    font-weight: 600;\n  }\n}\n\n.production-focus-tooltip-title {\n  display: flex;\n  align-items: center;\n\n  gap: 7px;\n\n  color: #475569;\n\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.production-focus-tooltip-dot {\n  width: 8px;\n  height: 8px;\n\n  flex-shrink: 0;\n\n  border-radius: 50%;\n}\n\n\n// ============================================================\n// Animations\n// ============================================================\n\n@keyframes productionMixFocusReveal {\n  from {\n    opacity: 0;\n\n    transform: translateY(10px) scale(0.99);\n  }\n\n  to {\n    opacity: 1;\n\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes productionMixSelectorReveal {\n  from {\n    opacity: 0;\n\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n\n    transform: translateY(0);\n  }\n}\n\n@keyframes productionFocusDetailsReveal {\n  from {\n    opacity: 0;\n\n    transform: translateX(12px);\n  }\n\n  to {\n    opacity: 1;\n\n    transform: translateX(0);\n  }\n}\n\n@keyframes productionFocusDotPulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.35);\n\n    opacity: 0.65;\n  }\n}\n\n\n// ============================================================\n// Responsive\n// ============================================================\n\n@media (max-width: 900px) {\n  .production-focus-content {\n    grid-template-columns: 1fr;\n  }\n\n  .production-focus-details {\n    margin-top: -20px;\n  }\n}\n\n@media (max-width: 600px) {\n  .production-mix-selector {\n    grid-template-columns: 1fr;\n  }\n\n  .production-focus-content {\n    min-height: auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .production-mix-focus,\n  .production-mix-selector-item,\n  .production-focus-details,\n  .production-focus-badge-dot {\n    animation: none;\n  }\n}\n\n\n// ============================================================\n// Top Rejection Card\n// ============================================================\n\n.top-rejection-card {\n  position: relative;\n\n  overflow: hidden;\n\n  animation: rejectionCardReveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;\n\n  &::before {\n    position: absolute;\n\n    top: -80px;\n    right: -80px;\n\n    width: 180px;\n    height: 180px;\n\n    content: \"\";\n\n    border-radius: 50%;\n\n    background:\n      radial-gradient(circle,\n        rgba(239, 68, 68, 0.1) 0%,\n        rgba(239, 68, 68, 0.03) 45%,\n        transparent 72%);\n\n    pointer-events: none;\n\n    animation: rejectionCardGlow 4s ease-in-out infinite;\n  }\n}\n\n\n// ============================================================\n// Header Attention Indicator\n// ============================================================\n\n.rejection-alert-indicator {\n  display: inline-flex;\n  align-items: center;\n\n  gap: 7px;\n\n  padding: 6px 9px;\n\n  border: 1px solid rgba(239, 68, 68, 0.15);\n\n  border-radius: 999px;\n\n  color: #dc2626;\n\n  background: rgba(239, 68, 68, 0.06);\n\n  font-size: 12px;\n  font-weight: 800;\n\n  letter-spacing: 0.03em;\n\n  text-transform: uppercase;\n}\n\n.rejection-alert-dot {\n  position: relative;\n\n  width: 7px;\n  height: 7px;\n\n  flex-shrink: 0;\n\n  border-radius: 50%;\n\n  background: #ef4444;\n\n  animation: rejectionAlertPulse 1.8s ease-in-out infinite;\n\n  &::after {\n    position: absolute;\n\n    inset: -4px;\n\n    content: \"\";\n\n    border: 1px solid rgba(239, 68, 68, 0.3);\n\n    border-radius: 50%;\n\n    animation: rejectionAlertRing 1.8s ease-out infinite;\n  }\n}\n\n\n// ============================================================\n// Reject List\n// ============================================================\n\n.reject-list {\n  display: flex;\n  flex-direction: column;\n\n  gap: 10px;\n}\n\n\n// ============================================================\n// Reject Row\n// ============================================================\n\n.reject-row {\n  position: relative;\n\n  display: grid;\n\n  grid-template-columns: 36px minmax(0, 1fr) auto;\n\n  align-items: center;\n\n  gap: 11px;\n\n  min-width: 0;\n\n  padding: 0px 13px 5px;\n\n  overflow: hidden;\n\n  border: 1px solid #e8edf5;\n\n  border-radius: 13px;\n\n  background:\n    linear-gradient(145deg,\n      #ffffff 0%,\n      #f8fafc 100%);\n\n  box-shadow:\n    0 3px 10px rgba(15, 23, 42, 0.035);\n\n  opacity: 0;\n\n  transform: translateY(16px) scale(0.985);\n\n  animation: rejectionRowReveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n\n  animation-delay: var(--reject-delay);\n\n  transition:\n    transform 0.25s ease,\n    border-color 0.25s ease,\n    box-shadow 0.25s ease,\n    background 0.25s ease;\n\n  &::after {\n    position: absolute;\n\n    top: 0;\n    left: 0;\n\n    width: 3px;\n    height: 100%;\n\n    content: \"\";\n\n    background:\n      linear-gradient(180deg,\n        #ef4444,\n        #f97316);\n\n    opacity: 0.6;\n\n    transition:\n      width 0.25s ease,\n      opacity 0.25s ease;\n  }\n\n  &:hover {\n    transform: translateY(-3px) scale(1.008);\n\n    border-color: rgba(239, 68, 68, 0.2);\n\n    background:\n      linear-gradient(145deg,\n        #ffffff 0%,\n        rgba(254, 242, 242, 0.55) 100%);\n\n    box-shadow:\n      0 12px 26px rgba(15, 23, 42, 0.08),\n      0 4px 10px rgba(239, 68, 68, 0.05);\n\n    &::after {\n      width: 5px;\n      opacity: 1;\n    }\n\n    .reject-rank {\n      transform: scale(1.08) rotate(-3deg);\n    }\n\n    .reject-percent {\n      transform: scale(1.06);\n    }\n  }\n\n  &.highest-rejection {\n    border-color: rgba(239, 68, 68, 0.24);\n\n    background:\n      linear-gradient(145deg,\n        rgba(254, 242, 242, 0.95),\n        #ffffff);\n\n    box-shadow:\n      0 8px 22px rgba(239, 68, 68, 0.08);\n\n    &::before {\n      position: absolute;\n\n      top: -60px;\n      right: -50px;\n\n      width: 130px;\n      height: 130px;\n\n      content: \"\";\n\n      border-radius: 50%;\n\n      background:\n        radial-gradient(circle,\n          rgba(239, 68, 68, 0.12),\n          transparent 68%);\n\n      animation: highestRejectGlow 3s ease-in-out infinite;\n    }\n  }\n}\n\n\n// ============================================================\n// Rank\n// ============================================================\n\n.reject-rank {\n  position: relative;\n  z-index: 1;\n\n  width: 32px;\n  height: 32px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  flex-shrink: 0;\n\n  border: 1px solid rgba(239, 68, 68, 0.14);\n\n  border-radius: 10px;\n\n  color: #dc2626;\n\n  background:\n    linear-gradient(145deg,\n      rgba(254, 242, 242, 0.95),\n      rgba(255, 255, 255, 1));\n\n  box-shadow:\n    0 4px 10px rgba(239, 68, 68, 0.07);\n\n  font-size: 11px;\n  font-weight: 900;\n\n  transition: transform 0.25s ease;\n}\n\n\n// ============================================================\n// Department Info\n// ============================================================\n\n.reject-info {\n  position: relative;\n  z-index: 1;\n\n  min-width: 0;\n}\n\n.reject-department-name-row {\n  display: flex;\n  align-items: center;\n\n  gap: 7px;\n\n  min-width: 0;\n\n  >strong {\n    overflow: hidden;\n\n    color: #0f172a;\n\n    font-size: 12px;\n    font-weight: 760;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n    letter-spacing: 0.9px;\n    text-transform: uppercase;\n    margin-top: 6px;\n  }\n}\n\n.highest-rejection-badge {\n  display: inline-flex;\n  align-items: center;\n\n  flex-shrink: 0;\n\n  padding: 3px 6px;\n\n  border-radius: 999px;\n\n  color: #dc2626;\n\n  background: rgba(239, 68, 68, 0.09);\n\n  font-size: 8px;\n  font-weight: 900;\n\n  letter-spacing: 0.03em;\n\n  text-transform: uppercase;\n\n  animation: highestBadgePulse 2s ease-in-out infinite;\n}\n\n.reject-quantity-text {\n  display: block;\n\n  margin-top: 4px;\n\n  color: #94a3b8;\n\n  font-size: 9px;\n  font-weight: 600;\n\n  strong {\n    color: #ef4444;\n\n    font-weight: 800;\n  }\n}\n\n\n// ============================================================\n// Progress Bar\n// ============================================================\n\n.reject-progress-track {\n  position: relative;\n\n  width: 100%;\n  height: 5px;\n\n  margin-top: 8px;\n\n  overflow: hidden;\n\n  border-radius: 999px;\n\n  background: #edf2f7;\n\n  box-shadow:\n    inset 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.reject-progress-value {\n  position: relative;\n\n  width: var(--reject-progress);\n  height: 100%;\n\n  overflow: hidden;\n\n  border-radius: inherit;\n\n  background:\n    linear-gradient(90deg,\n      #ef4444 0%,\n      #f97316 100%);\n\n  transform-origin: left center;\n\n  animation: rejectionProgressGrow 1.2s cubic-bezier(0.22, 1, 0.36, 1) both;\n\n  animation-delay: calc(var(--reject-delay) + 250ms);\n\n  &::after {\n    position: absolute;\n\n    top: 0;\n    left: -50%;\n\n    width: 40%;\n    height: 100%;\n\n    content: \"\";\n\n    background:\n      linear-gradient(90deg,\n        transparent,\n        rgba(255, 255, 255, 0.75),\n        transparent);\n\n    transform: skewX(-20deg);\n\n    animation: rejectionProgressShimmer 2.4s ease-in-out infinite;\n\n    animation-delay: calc(var(--reject-delay) + 1.2s);\n  }\n}\n\n.reject-progress-glow {\n  position: absolute;\n\n  top: 50%;\n  right: 0;\n\n  width: 8px;\n  height: 8px;\n\n  border-radius: 50%;\n\n  background: #ffffff;\n\n  box-shadow:\n    0 0 8px rgba(239, 68, 68, 0.85),\n    0 0 14px rgba(249, 115, 22, 0.55);\n\n  opacity: 0.9;\n\n  transform: translate(40%, -50%);\n\n  animation: rejectionProgressDotPulse 1.8s ease-in-out infinite;\n}\n\n\n// ============================================================\n// Percentage\n// ============================================================\n\n.reject-percent-wrapper {\n  position: relative;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n\n  gap: 3px;\n\n  min-width: 70px;\n\n  >small {\n    color: #94a3b8;\n\n    font-size: 12px;\n    font-weight: 640;\n\n    letter-spacing: 0.02em;\n\n    text-transform: uppercase;\n  }\n}\n\n.reject-percent {\n  display: inline-flex;\n  align-items: baseline;\n\n  padding: 7px 9px;\n\n  border: 1px solid rgba(239, 68, 68, 0.12);\n\n  border-radius: 9px;\n\n  color: #dc2626;\n\n  background:\n    linear-gradient(145deg,\n      rgba(254, 242, 242, 1),\n      rgba(255, 255, 255, 1));\n\n  box-shadow:\n    0 4px 10px rgba(239, 68, 68, 0.06);\n\n  font-size: 14px;\n  font-weight: 900;\n\n  line-height: 1;\n\n  letter-spacing: -0.025em;\n\n  transition: transform 0.25s ease;\n\n  span {\n    margin-left: 1px;\n\n    font-size: 9px;\n    font-weight: 800;\n  }\n}\n\n\n// ============================================================\n// Animations\n// ============================================================\n\n@keyframes rejectionCardReveal {\n  from {\n    opacity: 0;\n\n    transform: translateY(12px) scale(0.99);\n  }\n\n  to {\n    opacity: 1;\n\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes rejectionRowReveal {\n  from {\n    opacity: 0;\n\n    transform: translateY(16px) scale(0.985);\n  }\n\n  to {\n    opacity: 1;\n\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes rejectionProgressGrow {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n@keyframes rejectionProgressShimmer {\n  0% {\n    left: -50%;\n  }\n\n  55%,\n  100% {\n    left: 130%;\n  }\n}\n\n@keyframes rejectionProgressDotPulse {\n\n  0%,\n  100% {\n    transform: translate(40%, -50%) scale(1);\n\n    opacity: 0.85;\n  }\n\n  50% {\n    transform: translate(40%, -50%) scale(1.35);\n\n    opacity: 1;\n  }\n}\n\n@keyframes rejectionAlertPulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.35);\n\n    opacity: 0.7;\n  }\n}\n\n@keyframes rejectionAlertRing {\n  0% {\n    transform: scale(0.7);\n\n    opacity: 0.8;\n  }\n\n  100% {\n    transform: scale(1.8);\n\n    opacity: 0;\n  }\n}\n\n@keyframes rejectionCardGlow {\n\n  0%,\n  100% {\n    transform: scale(1);\n\n    opacity: 0.7;\n  }\n\n  50% {\n    transform: scale(1.15);\n\n    opacity: 1;\n  }\n}\n\n@keyframes highestRejectGlow {\n\n  0%,\n  100% {\n    transform: scale(1);\n\n    opacity: 0.5;\n  }\n\n  50% {\n    transform: scale(1.2);\n\n    opacity: 0.9;\n  }\n}\n\n@keyframes highestBadgePulse {\n\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 0 rgba(239, 68, 68, 0);\n  }\n\n  50% {\n    box-shadow:\n      0 0 0 5px rgba(239, 68, 68, 0.07);\n  }\n}\n\n\n// ============================================================\n// Responsive\n// ============================================================\n\n@media (max-width: 600px) {\n  .reject-row {\n    grid-template-columns: 30px minmax(0, 1fr);\n\n    gap: 9px;\n  }\n\n  .reject-percent-wrapper {\n    grid-column: 2;\n\n    align-items: flex-start;\n\n    margin-top: 3px;\n  }\n\n  .rejection-alert-indicator {\n    display: none;\n  }\n}\n\n\n// ============================================================\n// Reduced Motion Accessibility\n// ============================================================\n\n@media (prefers-reduced-motion: reduce) {\n\n  .top-rejection-card,\n  .reject-row,\n  .reject-progress-value,\n  .reject-progress-value::after,\n  .reject-progress-glow,\n  .rejection-alert-dot,\n  .rejection-alert-dot::after,\n  .highest-rejection-badge {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
